<script context="module">
  import {External, M} from "../external";
  import StripeUpgradePrompt  from "./StripeUpgradePrompt.svelte";
  export function showStripeUpgradePrompt() {
    External.Tools.showWindow({
      noTitle: true,
      noNav: true,
      width: 900,
      isModal: false,
      withDarkBackground: true,
      showCloseButton: true,
      action: {
        onShow: function (popup, ui) {
          popup.bindComponent(
            new StripeUpgradePrompt({
              target: popup.getContentArea(),
              props: {
              }
            })
          );
        }
      }
    });
  }
</script>

<script>
  let setupStripeConnect = () => {
    External.UITools.setupStripeConnect();
  };
</script>
<style>


  .stripe-popup .popup-content {
    font-size: 16px;
    color: #666;
    line-height: 1.6;
  }

  .stripe-popup .popup-content li {
    list-style: disc;
    margin-bottom: 5px;
  }

  .stripe-popup .popup-content ul {
    padding-left: 15px;
  }

  .stripe-popup h2 {
    font-size: 34px;
  }

  .stripe-popup .middle-button {
    padding: 5px 45px;
    font-size: 17px;
    background: #635bff !important;
  }

  .popup-widget-wrapper.stripe-popup {
    padding: 50px;
  }

  .stripe-popup .col12 {
    padding-right: 25px;
    box-sizing: border-box;
  }

  .stripe-popup .col8 {
    position: relative;
  }

  .stripe-popup .col8:after {
    content: '';
    height: 200px;
    left: 20px;
    right: 20px;
    top: 50%;
    margin-top: -100px;
    border-radius: 5px;
    background: #635bff;
    position: absolute;
    z-index: 1;
  }

  .stripe-popup .col8 img {
    z-index: 2;
  }
</style>

<div class="popup-widget-wrapper flex stripe-popup">
  <a class="close-btn close-popup"><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"></path></svg></a>
  <div class="col12 f-left">
    <h2 class="col20 f-left mt-15 mb-10 t-left"><b>{M.RECONNECT_STRIPE_TITLE}</b></h2>
    <span class="light-gray-text f-15 t-left col20 f-left"><b class="red-text">{M.ACTION_REQUIRED}</b></span>
    <div class="col20 f-left mt-25 popup-content">
      <span class="col20 f-left mb-15">{@html M.RECONNECT_STRIPE_MESSAGE}</span>
      <div class="col20 f-left"><a on:click={setupStripeConnect} class="middle-button blue">{M.RECONNECT_STRIPE_ACTION}</a></div>
      <b class="col20 f-left mt-25">{M.RECONNECT_STRIPE_BENEFIT_TITLE}</b>
      <ul class="col20 f-left mt-10 mb-10">
        <li>{M.RECONNECT_STRIPE_BENEFIT_1}</li>
        <li>{M.RECONNECT_STRIPE_BENEFIT_2}</li>
        <li>{M.RECONNECT_STRIPE_BENEFIT_3}</li>
      </ul>
    </div>
  </div>
  <div class="col8 f-right flex align-center justify-center mt-10">
    <img src="{External.resources + '/images/stripe-white.png'}" >
  </div>
</div>